// import external dependencies
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

// Import everything from autoload
import './components/_countdown';
import './components/_dotmailer';
import './components/_filters';
import './components/_woocommerce';
import './components/_checkout';
import 'bootstrap/js/src/modal.js';
import '../../modules/accordions/assets/js/accordions';
import '../../modules/advice-list/assets/js/advice-list';
import '../../modules/banner/assets/js/banner';
import '../../modules/careers-apply/assets/js/careers-apply';
import '../../modules/careers-list/assets/js/careers-list';
import '../../modules/content-50-slider-50/assets/js/content-slider-50';
import '../../modules/content-image-50/assets/js/content-image-50';
import '../../modules/countdown-sale/assets/js/countdown-sale';
import '../../modules/form/assets/js/form';
import '../../modules/gallery/assets/js/gallery';
import '../../modules/logo-section/assets/js/logo-section';
import '../../modules/main-banner/assets/js/main-banner';
import '../../modules/news-grid/assets/js/news-grid';
import '../../modules/number-icon-steps/assets/js/number-icon-steps';
import '../../modules/page-link-boxes/assets/js/page-link-boxes';
import '../../modules/product-carousel/assets/js/product-carousel';
import '../../modules/product-questions-answers/assets/js/product-questions-answers';
import '../../modules/quick-nav/assets/js/quick-nav';
import '../../modules/review-carousel/assets/js/review-carousel';
import '../../modules/review-list/assets/js/review-list';
import '../../modules/trustpilot-review-carousel/assets/js/review-carousel';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import blog from './routes/blog';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Posts page
  blog,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());